import Vue from 'vue';

import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/en.json';

import { ValidationProvider, ValidationObserver } from 'vee-validate';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule], // assign message
  });
  extend('percentVal' , (val) => {
    const isSymbolsExists = /[^0-9]/.test(val);
    if(isSymbolsExists) {
      return 'This field must contain only numeric values';
    }

    if(+val > 100 || +val < 0) {
      return 'The value range must be between 0 - 100';
    }
    return true;
  });
});
